import React from 'react';
import ReactDOM from 'react-dom';
import * as serviceWorker from './serviceWorker';
import history from "./history";
import configureStore from "./store/configureStore";
import Root from "./containers/Root";
import "semantic-ui-css/semantic.min.css";
import './index.css';

const store = configureStore(true);

ReactDOM.render(<Root store={store} history={history} />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
